import {Component, Event, type EventEmitter, h, Prop, State} from '@stencil/core';
import {widgetStatistics} from './faq-statistics';
import type {AnalyticsGenericEvent} from '../../../utils/analytics/AnalyticsGenericEvent';
import { makeLogger } from '../../../logger/logger';

const { warn } = makeLogger({
  pathToCurrentFile: 'components/widgets/faq/faq.single.component.tsx',
  loggersList: ['warn']
});

@Component({
  tag: 'uiaas-search-widget-faq-single',
  styleUrl: 'faq.scss',
  shadow: false
})
export class WidgetFaqItem {
  @Prop() readonly question: string;
  @Prop() readonly answer: string;
  @Prop() readonly url: string;

  @State() isOpened = false;

  @Prop() readonly seeMoreLabel?: string;

  @Prop({reflect: true})
  readonly faqId: string;

  @Event() open: EventEmitter<any>; //eslint-disable-line
  @Event() gotoFaq: EventEmitter<any>;//eslint-disable-line
  @Prop() readonly searchResultPosition: number;

  @Prop() readonly tabName: string;

  @Prop() readonly getClickType;
  @Prop() readonly analyticsTabName: string;

  @Event({
    eventName: 'search:widgetEvent',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    statisticsEventEmitter: EventEmitter<AnalyticsGenericEvent>;

  private ellipsed(text) {
      if (!text)
        return <span/>;
      if (text.length < 300) {
        return <p class="answer-text" innerHTML={this.answer}/>;
      } else {
        return <p class="answer-text" innerHTML={this.answer.substr(0, 300) + '&mldr;'}/>;
      }
  }

  private toggle(e) {
      if (!e.target.classList.contains('more-link__link')) {
        this.isOpened = !this.isOpened;
      }
  }

  private handleUnfoldEvents(e): void {
      if (!e.target.classList.contains('more-link__link')) {
        this.emitSearchStatisticsEvent(widgetStatistics.sendUnfoldStatisticsEvent(this.analyticsTabName, this.searchResultPosition, this.faqId, !this.isOpened));
      }
  }


  private handleRedirectEvent(e): void {
      const clickType = this.getClickType(e);
      this.emitSearchStatisticsEvent(widgetStatistics.sendRedirectionLearnMoreStatisticsEvent(this.analyticsTabName, clickType, this.searchResultPosition, this.faqId, this.url));
  }

  private emitSearchStatisticsEvent = (e: AnalyticsGenericEvent) => {
      this.statisticsEventEmitter.emit(
        e
      );
  };

  render() {
      return <div onClick={(e) => this.toggle(e)}
        onMouseDown={(e) => this.handleUnfoldEvents(e)}
        onKeyDown={e => {
            if (e.key === 'Enter') {
              this.handleUnfoldEvents(e);
            }
        }} class={['faq-item', this.isOpened ? 'opened' : ''].join(' ')}>
        <div class={this.isOpened ? 'question question-green' : 'question'}>
          <p class="question-text" innerHTML={this.question}/>
          <button class="button-faq">
            <div
              class={`button-faq__arrow${this.isOpened ? '--rotated' : ''}`}
            />
          </button>

        </div>
        {this.isOpened ? <div class="answer">
          {this.ellipsed(this.answer)}
          <div class='more-link'>
            <qds-standalone-link href={this.url}
              rel="external"
              onMouseDown={(e) => this.handleRedirectEvent(e)}
              onKeyDown={e => {
                  if (e.key === 'Enter') {
                    this.handleRedirectEvent(e);
                  }
              }}>
              {this.seeMoreLabel}
            </qds-standalone-link>
          </div>
        </div> : ''}
      </div>;
  }

}
